"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16GlobeFill = function Svg16GlobeFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M12 20c-1.063 0-1.932-3.315-1.996-7.5h3.992C13.932 16.685 13.063 20 12 20zM9.683 19.66a8.006 8.006 0 0 1-5.668-7.16h4.489c.03 2.103.256 4.04.627 5.52.146.587.327 1.15.552 1.64zM4.062 11h4.453c.057-1.909.275-3.658.616-5.02a9.476 9.476 0 0 1 .552-1.64A8.008 8.008 0 0 0 4.062 11zM14.317 4.34c.225.49.406 1.053.552 1.64.341 1.362.56 3.111.616 5.02h4.453a8.008 8.008 0 0 0-5.621-6.66zM19.985 12.5h-4.489c-.03 2.103-.256 4.04-.627 5.52a9.475 9.475 0 0 1-.552 1.64 8.005 8.005 0 0 0 5.668-7.16zM13.985 11h-3.97c.123-3.946.965-7 1.985-7s1.861 3.054 1.985 7z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16GlobeFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16GlobeFill;
exports.default = _default;